module.exports = __webpack_public_path__ + "static/media/0009_Medium.e337cbc1.jpg";